import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'vs-bundle-play-btn',
  styleUrl: './_vs-bundle-play-btn.scss',
})
export class BundlePlayButton {
  @Prop() videoLayout: string;
  @Prop() playBtnColor: string;
  @Prop() videoUrl: string;
  @Prop() videoTitle: string;
  @Prop() thumbnailPath: string;
  @Prop() videoPlayAriaValue: string;

  @State() videoAltText = '';
  @State() videoId = '';
  @State() classList = '';

  componentWillLoad() {
    this.videoAltText = this.videoPlayAriaValue + ' ' + this.videoTitle;
    this.videoId = this.videoUrl.split('watch?v=')[1];
    this.classList += 'modal__show ' + 'vs-bundle-play-' + this.playBtnColor + ' vs-bundle-' + this.videoLayout;
  }

  render() {
    return (
      <button
        class={this.classList}
        aria-label={this.videoAltText}
        data-title={this.videoTitle}
        data-toggle="modal"
        data-target={this.videoId}
        data-modaltype="video"
        data-image={this.thumbnailPath}
        data-videoid={this.videoId}
        role="button"
      ></button>
    );
  }
}
